import { getCookieValue } from './getCookieValue';
import { Cookie } from './types';

export function getAbUuid(cookie: Cookie): string | null {
    return getCookieValue(cookie, 'ab_uuid');
}
